module.exports = __webpack_public_path__ + "img/img_drug.0511b872.jpg";